import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgAddress = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M13.375 32.082c0-4.195 0-6.293.952-8.032s2.69-2.818 6.169-4.977l3.666-2.275c3.677-2.282 5.515-3.423 7.546-3.423s3.87 1.14 7.546 3.423l3.667 2.275c3.478 2.159 5.217 3.238 6.169 4.977s.952 3.837.952 8.032v2.789c0 7.151 0 10.727-2.148 12.949s-5.605 2.222-12.519 2.222h-7.333c-6.914 0-10.371 0-12.52-2.222-2.147-2.222-2.147-5.798-2.147-12.95z"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M48.667 32.083c0-2.124-.002-3.622-.113-4.81-.11-1.159-.315-1.916-.67-2.563-.353-.645-.87-1.213-1.767-1.9-.922-.706-2.16-1.476-3.92-2.569l-3.667-2.276c-1.862-1.155-3.172-1.965-4.267-2.497-1.066-.519-1.822-.718-2.555-.718s-1.488.2-2.554.718c-1.095.532-2.405 1.342-4.267 2.497l-3.667 2.276c-1.761 1.093-2.998 1.863-3.92 2.57-.898.686-1.415 1.254-1.768 1.899-.354.647-.56 1.404-.67 2.564-.11 1.187-.112 2.685-.112 4.809v2.787c0 3.613.004 6.19.258 8.146.25 1.922.72 3.037 1.504 3.848.778.804 1.836 1.282 3.672 1.538 1.88.261 4.36.265 7.858.265h7.333c3.497 0 5.978-.004 7.858-.265 1.835-.256 2.894-.734 3.672-1.538.784-.811 1.254-1.926 1.504-3.848.254-1.956.258-4.533.258-8.146zm2.75 2.787c0 3.538.003 6.326-.28 8.5-.287 2.21-.892 3.995-2.255 5.406-1.37 1.417-3.113 2.05-5.271 2.35-2.114.294-4.82.29-8.236.29h-7.333c-3.417 0-6.122.005-8.236-.29-2.158-.3-3.901-.933-5.27-2.35-1.364-1.41-1.97-3.195-2.257-5.405-.282-2.175-.279-4.963-.279-8.5v-2.788c0-2.073-.001-3.722.125-5.067.13-1.373.398-2.534.996-3.626s1.427-1.936 2.506-2.762c1.055-.808 2.427-1.658 4.143-2.723l3.667-2.276c1.814-1.126 3.262-2.027 4.513-2.635 1.28-.623 2.46-.994 3.758-.994s2.479.371 3.758.994c1.252.608 2.7 1.51 4.514 2.635l3.667 2.276c1.716 1.065 3.088 1.915 4.142 2.723 1.08.826 1.908 1.669 2.507 2.762.597 1.092.866 2.253.995 3.626.127 1.345.126 2.994.126 5.067z"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M35.932 33.812a1.375 1.375 0 0 1 1.636 2.209 10.57 10.57 0 0 1-6.318 2.104c-2.356 0-4.536-.783-6.318-2.104a1.375 1.375 0 0 1 1.636-2.21 7.82 7.82 0 0 0 4.682 1.564 7.82 7.82 0 0 0 4.682-1.563"
      />
    </svg>
  );
};
export default SvgAddress;
